import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { RecommendationService } from '../../../../core/services/recommendation.service';
import { EventService } from '../../../../core/services/event.service';
import { FuseDeleteDialogComponent } from '../../../../core/components/delete-dialog/delete-dialog.component';
import { DocumentsService } from '../../../../core/services/documents.service';
import { RecommendationDetailModal } from '../recommendation-detail-modal/recommendation-detail.modal';
import { SubscriptionService } from '../../../../core/services/subscription.service';

@Component({
  selector: 'recommended-elearning',
  templateUrl: './recommended-elearning.component.html',
  styleUrls: ['./recommended-elearning.component.scss'],
  standalone: false
})

export class RecommendedElearningComponent implements OnInit {
  @Input() elearning: any;
  @Input() index: any;
  @Output() deleteElearning = new EventEmitter();
  @Output() removeFavorite = new EventEmitter();
  public videoUrl;

  constructor(private _sanitizer: DomSanitizer, public snackBar: MatSnackBar,
              private translate: TranslateService, public dialog: MatDialog,
              private recommendationService: RecommendationService,
              private eventService: EventService, private documentService: DocumentsService,
              private subscriptionService: SubscriptionService) {
  }

  ngOnInit() {
  }

  toggleFavorite(elearning) {
    if (elearning.isFavorite && elearning.favId) {
      this.recommendationService.removeFavoriteRecommendation(elearning.favId).subscribe((result) => {
        elearning.isFavorite = false;
        elearning.favId = null
        this.removeFavorite.emit(this.index);
      });
    } else {
      let data = {
        recommendationId: elearning.id,
      }
      this.recommendationService.addFavoriteRecommendation(data).subscribe((result: any) => {
        elearning.isFavorite = true;
        elearning.favId = result.id;
      });
    }
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  getElearningImage(name) {
    return this.documentService.getFileStream(name);
  }

  subscriptionToElearning (id, index) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'elearning.subscribe_to_elearning' , message: 'elearning.subscription_question'}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.subscriptionService.addElearningSubscription({elearningId: id}).subscribe((res) => {
          if (res) {
            this.deleteElearning.emit(index);
            let message = this.translate.instant('elearning.subscription_confirm_message');
            this.snackBar.open(message , 'OK' , {
              verticalPosition: 'top' ,
              panelClass: 'sub-to-event-bar'
            });
          }
        });
      }
    });
  }

  openDetail(elearning, index){
    const dialogRef = this.dialog.open(RecommendationDetailModal, {
      width: '80%',
      height: '90vh',
      data: {elearning: JSON.parse(JSON.stringify(elearning))}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.subscriptionToElearning(elearning.elearning.id, index)
      }
    })
  }
}
